<template>
    <div class="solutionsSection stockageSection" id="solutions-logistique">
        <h2>{{ $t('storage.bigTitle') }}</h2>
        <div class="solutionContainer">
            <div class="solutionSection">
                <picture class="solutionImg solutionImgComment">
                    <source :srcset="require('@/assets/solutions/gestionnaire-stock-optimisation.webp')" type='image/webp' />
                    <img :src="require('@/assets/solutions/gestionnaire-stock-optimisation.jpg')" alt="Entrepôt intérieur large rangé avec des palettes entreposés" loading="lazy" />
                </picture>
                <div class="solutionContent">
                    <h3 class="solutionH3">{{ $t('storage.title') }}</h3>
                    <h4 class="solutionsIntro">{{ $t('storage.subtitle') }}</h4>
                    <div class="solutionText"> 
                        {{ $t('storage.paragraph1') }}
                    </div>
                    <div class="isExpanded">
                        <div class="expandedSection">
                            <div class="paraf">
                                <div class="expandedTxt expandedP1">
                                    {{ $t('storage.paragraph2') }}
                                </div>
                            </div>
                            <div class="paraf">
                                <div class="expandedTxt expandedP2">
                                    {{ $t('storage.paragraph3') }}
                                </div>
                            </div>
                            <div class="customerComment">
                                <!-- <picture class="customerImg">
                                    <source :srcset="require('@/assets/solutions/client-satisfaction-logistique.webp')" type='image/webp' />
                                    <img :src="require('@/assets/solutions/client-satisfaction-logistique.jpg')" alt="Visage d'un client donnant son avis sur nos solutions de stockage" loading="lazy" />
                                </picture> -->
                                <picture class="quote">
                                    <source :srcset="require('@/assets/icons/temoignage-GMA.webp')" type='image/webp' />
                                    <img :src="require('@/assets/icons/temoignage-GMA.png')" alt="icône de guillemet" loading="lazy" />
                                </picture>
                                <div class="commentSection">
                                    <div class="commentText">{{ $t('storage.comment') }}</div>
                                    <div class="commentDetails">
                                        <div>Jules Varnel</div>
                                        <div>{{ $t('storage.function') }}</div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
 
<style scoped>
h2 {
    text-align: left;
    color: #e91e63;
    font-size: 45px;
    text-align: center;
    margin-bottom: 100px;
}
.solutionsSection {
    margin: 50px 0;
    padding: 0 30px;
    max-width: 1440px;
    margin: auto;
}
.solutionImg {
    margin-left: 0;
    box-shadow: 0 0 20px 10px rgba(0, 0, 0, 0.2);
}

@media screen and (min-width: 2000px ) {
    .solutionsSection {
        display: flex;
        flex-direction: column;
        padding: 0;
    }
}

    

@media screen and (max-width: 750px ) {
   h2 {
    margin-bottom: 25px;
   } 
   .solutionImgComment {
    top: 1%;
   }
   .stockageSection {
    margin-bottom: 80px;
   }
}
 


</style>